import { useState, useEffect, useCallback } from 'react';

// ----------------------------------------------------------------------
// Per-user opt-out of the special theme.
//
// The active theme is forced globally by an admin, but any user can turn it
// off for themselves. The choice is stored in localStorage (per browser) and
// propagated immediately to all mounted components via a custom event, plus
// across tabs via the native `storage` event.
// ----------------------------------------------------------------------

const KEY = 'theme:optOut';
const EVENT = 'theme-optout-change';

function read() {
  try {
    return window.localStorage.getItem(KEY) === 'true';
  } catch (e) {
    return false;
  }
}

export function useThemeOptOut() {
  const [optedOut, setOpted] = useState(read);

  useEffect(() => {
    const sync = () => setOpted(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);
    return () => {
      window.removeEventListener(EVENT, sync);
      window.removeEventListener('storage', sync);
    };
  }, []);

  const setOptedOut = useCallback((value) => {
    try {
      window.localStorage.setItem(KEY, value ? 'true' : 'false');
    } catch (e) {
      // ignore
    }
    window.dispatchEvent(new Event(EVENT));
  }, []);

  return { optedOut, setOptedOut };
}
